/* Produktfinder-Attribution (Farben Löwe) — schreibt pf_session als Cart-Attribut,
 * damit jede Bestellung der Session zuverlässig dem Produktfinder zugeordnet wird
 * (note_attribute-Weg im Webhook). Rein additiv, gekapselt. Claude 2026-05-30. */
(function () {
  "use strict";
  try {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get("pf_session");
    if (fromUrl) {
      try { localStorage.setItem("pf_session", fromUrl); } catch (e) {}
      try { document.cookie = "pf_session=" + encodeURIComponent(fromUrl) + ";path=/;max-age=" + (60 * 60 * 24 * 30) + ";SameSite=Lax"; } catch (e) {}
    }
    var stored = fromUrl;
    if (!stored) { try { stored = localStorage.getItem("pf_session"); } catch (e) {} }
    if (!stored) { var m = document.cookie.match(/(?:^|;\s*)pf_session=([^;]+)/); if (m) stored = decodeURIComponent(m[1]); }
    if (!stored) return;

    // Cart-Attribut nur setzen, wenn noch nicht (oder abweichend) gesetzt — vermeidet unnötige Requests.
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.attributes && cart.attributes.pf_session === stored) return;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: { pf_session: stored } })
        });
      })
      .catch(function () {});
  } catch (e) {}
})();
